import BENEFICIARY_SUBJECT_TYPE_KEY from '@Domain/Subjects/BeneficiarySubjectTypeKey';
import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import Container from '@Guidelines/Component/Container';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import ChooseWorkflowContent from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Preparations/ChooseWorkflow/ChooseWorkflowContent';
import PreparationsNotifications from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Shared/PreparationsNotifications';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import SubjectBreadcrumb from '@UI/Pages/Beneficiaries/Shared/SubjectBreadcrumb';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const BREADCRUMB_ITEMS = [{ label: 'Commencer des documents' }] as const;

/**
 * Mounted from `…/:dossier/preparations/new`. Same validation motif as
 * `DocumentDetails/index.tsx`: an invalid dossier address redirects to the beneficiary list.
 */
const ChooseWorkflow: React.FC = () => {
	const navigate = useNavigate();
	const { subject } = useSubjectAddressParams();

	React.useEffect(() => {
		if (subject === null) {
			navigate(buildSubjectListPath(BENEFICIARY_SUBJECT_TYPE_KEY));
		}
	}, [subject, navigate]);

	return (
		<Container>
			<ConditionalLoader data={subject}>
				{(validSubject) => (
					<React.Fragment>
						<SubjectBreadcrumb subject={validSubject} items={BREADCRUMB_ITEMS} />
						<ChooseWorkflowContent subject={validSubject} />
					</React.Fragment>
				)}
			</ConditionalLoader>
			<PreparationsNotifications />
		</Container>
	);
};

export default ChooseWorkflow;
